import { createSlice } from '@reduxjs/toolkit'
import APILoadingStatus from 'types/api-loading-status'
import asyncReducers from '../../../utils/async-reducers'
import { sendEmails, sendMessages } from './outreach.actions'
import toast from 'react-hot-toast'

// Helper to safely handle error messages that can be string or boolean
const getErrorMessage = (error: string | boolean): string =>
  typeof error === 'string' ? error : 'An error occurred'

export type OutreachState = {
  messageStatus: APILoadingStatus
  emailStatus: APILoadingStatus
}

const initialState: OutreachState = {
  messageStatus: APILoadingStatus.Idle,
  emailStatus: APILoadingStatus.Idle,
}

const outreachSlice = createSlice({
  name: 'outreach',
  initialState,
  reducers: {},
  extraReducers: builder => {
    asyncReducers(builder, sendMessages, 'messageStatus', (state, action) => {
      if (action.payload.error) {
        toast.error(getErrorMessage(action.payload.error))
      } else {
        toast.success('Your message was sent.')
      }
    })
    asyncReducers(builder, sendEmails, 'emailStatus', (state, action) => {
      if (action.payload.error) {
        toast.error(getErrorMessage(action.payload.error))
      } else {
        toast.success('Your message was sent.')
      }
    })
  },
})

export default outreachSlice.reducer
export const outreachActions = {
  ...outreachSlice.actions,
  sendMessages,
  sendEmails,
}
